import { FC } from 'react'
import PageWrapper from 'components/PageWrapper'
import PAGE_CONSTANT_TEXTS from 'constants/pageMetaTags'
import ContactUsPage from 'components/ContactUsPage'
import BreadcrumbList from 'components/StructuredData'

export async function getStaticProps() {
  return {
    props: { isErrorCls: true },
  }
}

const Contact: FC = () => {
  return (
    <PageWrapper {...PAGE_CONSTANT_TEXTS.contact}>
      <BreadcrumbList nameH1={PAGE_CONSTANT_TEXTS.contact.meta.title} />
      <ContactUsPage />
    </PageWrapper>
  )
}

export default Contact
